'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'For Candidates', href: '/candidate' },
  { label: 'For Employers', href: '/employer' },
  { label: 'Directory', href: '/directory' },
  { label: 'Framework', href: '/framework' },
  { label: 'Pricing', href: '/employer#pricing' },
  { label: 'About', href: '/about' },
];

export default function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-border" style={{ boxShadow: '0 1px 4px rgba(43,41,38,0.08)' }}>
      <div className="max-w-screen-xl mx-auto px-4 lg:px-8 flex items-center justify-between h-16">
        <Link href="/" className="flex items-center gap-2.5 flex-shrink-0">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ background: 'var(--amber)' }}>
            H
          </div>
          <div>
            <span className="font-bold text-base tracking-tight" style={{ color: 'var(--charcoal)', fontFamily: 'var(--font-serif)' }}>
              Handlenders
            </span>
            <div className="text-[9px] font-medium leading-none" style={{ color: 'var(--muted-foreground)' }}>Talent Network</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-0.5">
          {navLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className="px-3 py-2 rounded-lg text-sm font-medium transition-colors hover:bg-muted"
              style={{ color: pathname === link?.href ? 'var(--primary)' : 'var(--foreground)' }}
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/sign-up-login" className="btn-outline text-sm py-2 px-4">
            Sign In
          </Link>
          <Link href="/directory" className="btn-primary text-sm py-2 px-4">
            Find Candidates
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-white animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 rounded-xl text-sm font-medium hover:bg-muted transition-colors"
                style={{ color: 'var(--foreground)' }}
              >
                {link?.label}
              </Link>
            ))}
            <div className="pt-3 border-t border-border mt-2 flex flex-col gap-2">
              <Link href="/sign-up-login" onClick={() => setMobileOpen(false)} className="btn-outline w-full text-center">
                Sign In
              </Link>
              <Link href="/directory" onClick={() => setMobileOpen(false)} className="btn-primary w-full text-center">
                Find Candidates
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}